import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "modal-exportation-audience__container" };
const _hoisted_2 = { class: "modal-exportation-audience__actions" };
const _hoisted_3 = ["disabled"];
const _hoisted_4 = ["disabled"];
import { ref, watch, computed } from 'vue';
import { fetchExportationColumns } from '@/features/AudienceManager/data';
import { useStore } from 'vuex';
import ExportationHeader from './ExportationHeader.vue';
import ExportationFastSelection from './ExportationFastSelection.vue';
import ExportationFields from './ExportationFields.vue';
import ModalExportSuccess from './ModalExportSuccess.vue';
import ModalExportError from './ModalExportError.vue';
import ModalExportPreview from './ModalExportPreview.vue';
import ModalProcessProgress from './ModalProcessProgress.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ModalExportationAudience',
    setup(__props) {
        const store = useStore();
        const groups = ref([]);
        const columns = ref([]);
        const selectedColumnsKeys = ref([]);
        const modalState = computed(() => store.state.audienceManager.showModal);
        const isModalVisible = computed({
            get: () => store.state.audienceManager.isVisible,
            set: value => store.commit('audienceManager/SET_VISIBILITY_MODAL', value),
        });
        const fetchExportationData = () => {
            fetchExportationColumns().then(response => {
                groups.value = response.groups;
                columns.value = Object.values(response.columns);
            });
        };
        const isColumnSelected = (columnKey) => selectedColumnsKeys.value.includes(columnKey);
        const selectColumn = (columnKey) => {
            const isAlreadySelected = isColumnSelected(columnKey);
            if (isAlreadySelected) {
                removeColumn(columnKey);
            }
            else {
                addColumn(columnKey);
            }
        };
        const removeColumn = (columnKey) => {
            const columnIndex = selectedColumnsKeys.value.indexOf(columnKey);
            if (columnIndex !== -1) {
                selectedColumnsKeys.value.splice(columnIndex, 1);
            }
        };
        const addColumn = (columnKey) => {
            selectedColumnsKeys.value.push(columnKey);
        };
        const selectAllColumns = () => {
            const allKeys = columns.value.map(column => column.key);
            const areAllSelected = allKeys.every(key => selectedColumnsKeys.value.includes(key));
            selectedColumnsKeys.value = areAllSelected ? [] : [...allKeys];
        };
        const selectGroup = (groupKey) => {
            const group = groups.value.find(group => group.key === groupKey);
            if (!group)
                return;
            const areAllSelected = group.columns.every(col => selectedColumnsKeys.value.includes(col));
            group.columns.forEach(columnKey => {
                if (areAllSelected) {
                    selectedColumnsKeys.value = selectedColumnsKeys.value.filter(key => key !== columnKey);
                }
                else if (!selectedColumnsKeys.value.includes(columnKey)) {
                    selectedColumnsKeys.value.push(columnKey);
                }
            });
        };
        const openPreviewModal = () => {
            store.commit('audienceManager/UPDATE_VISIBILITY_MODAL', { type: 'preview', value: true });
        };
        const saveExportAudience = () => {
            store.dispatch('audienceManager/saveExportAudience', selectedColumnsKeys.value);
        };
        const closeExportModal = () => {
            store.commit('audienceManager/ACTIVATE_EXPORTATION_AUDIENCE_MODAL', false);
        };
        const clearAllSelections = () => {
            selectedColumnsKeys.value = [];
        };
        watch(isModalVisible, value => {
            fetchExportationData();
            isModalVisible.value = value ?? true;
        }, { immediate: true });
        return (_ctx, _cache) => {
            const _component_el_dialog = _resolveComponent("el-dialog");
            return (_openBlock(), _createBlock(_component_el_dialog, {
                modelValue: isModalVisible.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((isModalVisible).value = $event)),
                "append-to-body": "",
                width: "820",
                class: "modal-exportation-audience",
                "destroy-on-close": "",
                "close-on-click-modal": false,
                "close-on-press-escape": false,
                "before-close": closeExportModal
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createVNode(ExportationHeader),
                        _createVNode(ExportationFastSelection, {
                            groups: groups.value,
                            onSelectGroup: selectGroup,
                            onSelectAll: selectAllColumns
                        }, null, 8, ["groups"]),
                        _createVNode(ExportationFields, {
                            columns: columns.value,
                            "selected-columns-keys": selectedColumnsKeys.value,
                            onToggle: selectColumn,
                            onClear: clearAllSelections
                        }, null, 8, ["columns", "selected-columns-keys"]),
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("button", {
                                class: "btn btn-secondary",
                                disabled: !selectedColumnsKeys.value.length,
                                onClick: openPreviewModal
                            }, _toDisplayString(_ctx.$t('audiences.exportation.btn-preview')), 9, _hoisted_3),
                            _createElementVNode("button", {
                                class: "btn",
                                onClick: saveExportAudience,
                                disabled: !selectedColumnsKeys.value.length
                            }, _toDisplayString(_ctx.$t('export')), 9, _hoisted_4)
                        ])
                    ]),
                    _createVNode(ModalProcessProgress),
                    _createVNode(ModalExportSuccess, {
                        modelValue: modalState.value.success,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((modalState.value.success) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(ModalExportError, {
                        modelValue: modalState.value.error,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((modalState.value.error) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(ModalExportPreview, { "selected-columns-keys": selectedColumnsKeys.value }, null, 8, ["selected-columns-keys"])
                ]),
                _: 1
            }, 8, ["modelValue"]));
        };
    }
});
